export const getTargetAccountIdSuffix = (targetAccountId: string | null | undefined): string => {
	return targetAccountId ? `?targetAccountId=${targetAccountId}` : '';
};
